import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

export default function DiscussionPostedContent({ ownerGroup, events }) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussion"
      values={{
        name: util.getEventNames(events),
        group: ownerGroup?.name || "Deleted",
        comment: events
          .filter((event) => event.comment)
          .map((event) => `"${event.comment}"`)
          .join(", "),
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
}
